import ClickOutside from 'vue-click-outside';
import Choices from 'choices.js';

export default {
	template: `
		<div class="field-select__select-wrap">
		<select class="field-select__select" :name="name" :id="name" :class="{'disabled': disabled}"
				placeholder="placeholder" placeholderValue="Не выбрано..."
				@change="selectItem($event)"
		>
			<option value="" placeholder="placeholder" disabled="disabled"
					selected="selected">Не выбрано...
			</option>
			<option :value="item.value" v-for="item in items" :selected="item == selected">{{ item.text }}
				<span v-if="item.today" class="dropdown-modern__item-info">сегодня</span>
			</option>
		</select>
		</div>
	`,
	props: {
		placeholder: {
			type: String,
			default: ""
		},
		items: {
			type: Array,
			default: []
		},
		required: {
			type: Boolean,
			default: false
		},
		selected: {
			type: Object,
			default() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		error: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			shoices: null,
		}
	},
	components: {},
	computed: {},
	methods: {
		clickOutside() {
			this.opened = false;
		},
		selectItem(event) {
			this.items.forEach((element) => {
				if (element.value == event.target.value) {
					this.$emit("dropdown-selected", element);
				}
			})
		}
	},
	directives: {
		ClickOutside
	},
	watch: {
		items: function (val) {
			this.shoices.clearChoices();
			this.shoices.setChoices(this.items);
		},
	},
	mounted() {
		const select = document.querySelector('#' + this.name);
		this.shoices = new Choices(select, {
			searchEnabled: false,
			placeholderValue: 'Выберите',
			shouldSort: false,
		});
	},
	created() {
	}
}

